export const hoursOfDay = [
  "12:00 AM",
  "01:00 AM",
  "02:00 AM",
  "03:00 AM",
  "04:00 AM",
  "05:00 AM",
  "06:00 AM",
  "07:00 AM",
  "08:00 AM",
  "09:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  "01:00 PM",
  "02:00 PM",
  "03:00 PM",
  "04:00 PM",
  "05:00 PM",
  "06:00 PM",
  "07:00 PM",
  "08:00 PM",
  "09:00 PM",
  "10:00 PM",
  "11:00 PM",
];

export const weekHeads = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const monthHeads = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export enum headerActions {
  NEXT = "NEXT",
  BACK = "BACK",
  TODAY = "TODAY",
}

export enum calendarViews {
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export enum labelAlignValues {
  LEFT = 'flex-start',
  RIGHT = 'flex-end',
  CENTER = 'center',
}